__turbopack_context__.v({
  "body": "schedule-module-scss-module___6I82a__body",
  "chevron": "schedule-module-scss-module___6I82a__chevron",
  "col": "schedule-module-scss-module___6I82a__col",
  "description": "schedule-module-scss-module___6I82a__description",
  "duration": "schedule-module-scss-module___6I82a__duration",
  "footer": "schedule-module-scss-module___6I82a__footer",
  "header": "schedule-module-scss-module___6I82a__header",
  "link": "schedule-module-scss-module___6I82a__link",
  "noEvents": "schedule-module-scss-module___6I82a__noEvents",
  "opened": "schedule-module-scss-module___6I82a__opened",
  "panel": "schedule-module-scss-module___6I82a__panel",
  "panels": "schedule-module-scss-module___6I82a__panels",
  "row": "schedule-module-scss-module___6I82a__row",
  "schedule": "schedule-module-scss-module___6I82a__schedule",
  "table": "schedule-module-scss-module___6I82a__table",
  "tickets": "schedule-module-scss-module___6I82a__tickets",
  "time": "schedule-module-scss-module___6I82a__time",
  "title": "schedule-module-scss-module___6I82a__title",
});
